
import SVG from "../../assets/404.svg";
const NotFound = () => {
    return (<section className="bg-white  px-6 py-12">
        <div className="container min-h-screen  mx-auto lg:flex lg:items-center lg:gap-12 p-11">
            <div className="relative w-full mt-12 lg:w-1/2 lg:mt-0">
                <img className="w-full max-w-lg lg:mx-auto" src={SVG} alt="" />
            </div>
            <div className="wf-ull lg:w-1/2">
                <p className="text-[150px] font-bold text-[#1062d0]"> 403</p>
                <h1 className="mt-3 text-3xl font-semibold text-gray-700- md:text-3xl">دسترسی محدود شده</h1>
                <p className="mt-4 text-gray-500 ">برای دریافت دسترسی با مدیر سیتم خود هماهنگ کنید</p>

                <div className="flex items-center mt-6 gap-x-3">
                    {/* <button className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 rtl:rotate-180">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                        </svg>
    
    
                        <span>بازگشت به خانه</span>
                    </button> */}

                    <button onClick={(ev) => {
                        ev.preventDefault();
                        window.location.href = "/dashboard";
                    }} className="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-[#1062D0] rounded-lg shrink-0 sm:w-auto hover:bg-blue-600  flex items-center justify-center place-content-center gap-1 ">
                        بازگشت به خانه
                        <>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 1L1 5M1 5L5 9M1 5L13 5" stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                        </>


                    </button>
                </div>
            </div>


        </div>
    </section>);
}

export default NotFound;